import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Response, TQueryParams, formatQueryParams, parseJsonApiResponse, prepareHeaders } from 'evolve-ui';

export enum CostCentersFilters {
  customers = 'customers',
  agencies = 'agencies',
}

export interface ICostCenter {
  id: string;
  reference: string;
  description: string;
}

// Define a service using a base URL and expected endpoints
export const costCentersApi = createApi({
  reducerPath: 'costCenters',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.GATSBY_COST_CENTERS_API_URL}`,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['CostCenter'],
  endpoints: (builder) => ({
    getCostCenters: builder.query<
      Response<ICostCenter>,
      TQueryParams
    >({
      providesTags: ['CostCenter'],
      query: formatQueryParams,
      transformResponse: parseJsonApiResponse<ICostCenter>,
    }),
  }),
});

export const { useGetCostCentersQuery } = costCentersApi;
